"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetChallengesResponseAllOfToJSON = exports.GetChallengesResponseAllOfFromJSONTyped = exports.GetChallengesResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetChallengesResponseAllOfFromJSON(json) {
    return GetChallengesResponseAllOfFromJSONTyped(json, false);
}
exports.GetChallengesResponseAllOfFromJSON = GetChallengesResponseAllOfFromJSON;
function GetChallengesResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'challenges': (json['challenges'].map(_1.ChallengeResponseWithAcceptanceFromJSON)),
    };
}
exports.GetChallengesResponseAllOfFromJSONTyped = GetChallengesResponseAllOfFromJSONTyped;
function GetChallengesResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'challenges': (value.challenges.map(_1.ChallengeResponseWithAcceptanceToJSON)),
    };
}
exports.GetChallengesResponseAllOfToJSON = GetChallengesResponseAllOfToJSON;
